import { forwardRef, type Ref, type SVGProps } from "react";
const IconCrownOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.219 8.62c.187-.363.55-.62.958-.62h1.57c.642 0 1.117.598.983 1.226-1.67 7.838-1.8 13.467-1.767 15.705A1.05 1.05 0 0 1 24.926 26H7.074a1.05 1.05 0 0 1-1.037-1.07c.033-2.237-.097-7.866-1.767-15.704A1.012 1.012 0 0 1 5.253 8h1.57c.409 0 .771.257.958.62 1.949 3.794 5.616 1.61 6.546-1.755.134-.486.552-.865 1.056-.865h1.234c.505 0 .922.38 1.056.865.93 3.364 4.598 5.55 6.546 1.755m-.914 3.633c.856-.374 1.565-.999 2.133-1.794A83 83 0 0 0 24.134 20H7.866a83 83 0 0 0-1.304-9.541c.568.795 1.277 1.42 2.133 1.793 1.185.518 2.408.447 3.46.04C13.917 11.615 15.293 10 16 8.168c.709 1.832 2.084 3.447 3.844 4.126 1.053.406 2.276.477 3.461-.04zM7.985 22c.035.768.05 1.436.054 2h15.922q.005-.847.053-2H7.986z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCrownOutlineSVG);
ForwardRef.displayName = "IconCrownOutline";
export { ForwardRef as IconCrownOutline };
